import React from "react"
import Link from "next/link"

import { Card, Button } from "react-bootstrap"

import Stars from "./Stars"
import Image from "./CustomImage"
import Icon from "./Icon"
import Avatar from "./Avatar"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const CardPortfolio = (props) => {
  const { data } = props

  return (
    <Card className="h-100 border-0 shadow">
      <div className="card-img-top overflow-hidden gradient-overlay">
        <Image
          src={`${data.img}`}
          width={1350}
          height={900}
          alt={data.title}
          loading={props.eager ? "eager" : "lazy"}
          className="img-fluid"
          sizes={
            props.sizes
              ? props.sizes
              : "(max-width:576px) 100vw, (max-width:991px) 50vw, (max-width:1149px) 30vw, 280px"
          }
        />
        {/*
        <Link href="#">
          <a
            className="tile-link"
            aria-label={`Read more about ${data.title}`}
          />
        </Link>
         <div className="card-img-overlay-bottom z-index-20">
          <div className="d-flex text-white text-sm align-items-center">
            <Avatar
              image={`/content/${data.avatar}`}
              className="me-2  avatar-border-white"
              cover
              priority={props.eager}
              alt="..."
            />

            <div>{data.person}</div>
          </div>
        </div>
        <div className="card-img-overlay-top text-end">
          <OverlayTrigger
            //trigger="click"
            delay={{ show: 250, hide: 400 }}
            //key={data.title}
            placement="left"
            overlay={
              <Popover id={`popover-positioned-${data.title}`}>
                <Popover.Header as="h3">{`Description`}</Popover.Header>
                <Popover.Body>
                  {data.description}
                </Popover.Body>
              </Popover>
            }
          >
            <span className="card-fav-icon position-relative z-index-40">
              <Icon icon="diploma-1" className="text-white" />
            </span>
          </OverlayTrigger>
        </div>
        */}
      </div>
      <Card.Body className="d-flex align-items-center">
        <div className="w-100">
          <OverlayTrigger
            trigger="click"
            delay={{ show: 250, hide: 400 }}
            //key={data.title}
            placement="auto"
            overlay={
              <Popover id={`popover-positioned-${data.title}`}>
                <Popover.Header as="h3">{`Description`}</Popover.Header>
                <Popover.Body>
                  {data.description}
                </Popover.Body>
              </Popover>
            }
          >
            <Card.Title as="h6">
              <a style={{ cursor: 'pointer' }} className="text-decoration-none text-dark">{data.title}</a>
            </Card.Title>
          </OverlayTrigger>
          <Card.Subtitle className="d-flex mb-3" as="div">
            <p className="flex-grow-1 mb-0 text-muted text-sm">
              {data.subtitle}
            </p>
            {/*             <p className="flex-shrink-1 mb-0 card-stars text-xs text-end">
              <Stars stars={data.stars} />
            </p> */}
          </Card.Subtitle>
          <Card.Text className="text-muted">
            <span className="h4 text-primary">{data.price}</span>
          </Card.Text>
        </div>
      </Card.Body>
    </Card>
  )
}

export default CardPortfolio
